
<div
  v-if="!cart.initial"
  class="ws-vue-cart-hijack top-menu-cart"
  :class="{ hidden: initialPlacement }"
>
  <a
    href="javascript:void(0)"
    class="account-menu-cart"
    :class="{
      'account-menu-cart--empty':
        !get(cart, 'items.length') || checkoutInProgress,
      'cursor-not-allowed': checkoutInProgress,
    }"
    @click="navigateToCart"
  >
    <img class="account-menu-cart__icon" :src="cartIcon" alt="" height="17" />
    <!-- hide cart real state while checkout is in progress so less users clicks cart while waiting -->
    <div v-if="!checkoutInProgress" class="account-menu-cart__count">
      {{ get(cart, 'items.length') }}
    </div>
    <span class="account-menu-cart__label">{{ $t('cart.explicit') }}</span>
    <span v-if="!checkoutInProgress" class="account-menu-cart__total">{{
      $n(get(cart, 'summary.price.vatExcluded'), 'currency')
    }}</span>
  </a>
</div>
<div v-else class="ws-vue-cart-hijack top-menu-cart">
  <q-spinner class="q-mr-sm" />
</div>
